import React from "react";
import { Title, BubbleSelectBlock, tokens, i18n } from "@simplybenefits/sb-ui-library";

/**
 * Renders the header section for the Plan Details page, including the title
 * and optional toggle between Benefits Card and Plan Details views.
 *
 * This component conditionally displays different UI based on the user's coverage type:
 * - For spending account only, marketplace only, and private label members: Shows only "Plan Details" title
 * - For regular members: Shows "Benefits Card" title and a toggle to switch between views
 * @param {boolean} props.showBenefitsCardOption - Whether to show the benefits card/plan details toggle (false for spending account only members)
 * @param {boolean} props.displayPlanDetails - Current view state: true for Plan Details view, false for Benefits Card view
 * @param {Function} props.onToggle - Callback function to handle toggling between Benefits Card and Plan Details views
 * @returns {JSX.Element} The Plan Details header with conditional title and toggle UI
 */
const PlanDetailsHeader = ({ showBenefitsCardOption, displayPlanDetails, onToggle }) => {
    const titleToken = showBenefitsCardOption 
        ? tokens.titles["benefits card"]
        : tokens.titles.planDetails;

    return (
        <>
            <Title title={i18n.t(titleToken)} />
            {
                showBenefitsCardOption && (
                    <BubbleSelectBlock 
                        first={{
                            title: i18n.t(tokens.titles["benefits card"]),
                            selected: !displayPlanDetails
                        }}
                        second={{
                            title: i18n.t(tokens.titles.planDetails),
                            selected: displayPlanDetails
                        }}
                        handleChange={onToggle}
                        customStyle={{ marginTop: 30, marginBottom: 30 }}
                        text={''}
                    />
                )
            }
        </>
    );
};

export default PlanDetailsHeader;